export default __webpack_public_path__ + "static/yoga-13-9b96a52da744d556cc32113f53ba8316.png";